(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/util.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/util.js');
"use strict";

const _excluded = ["gameProvider", "category", "shouldTriggerQualtrics"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const E_INSTANT_CATEGORY = 'fler-lotter';
const createGameConfig = _ref => {
  let config = _ref.config,
    images = _ref.images,
    gameProvider = _ref.gameProvider;
  const url = config.url,
    badge = config.badge,
    name = config.name,
    height = config.height,
    width = config.width,
    margin = config.margin,
    image = config.image,
    imageBackground = config.imageBackground,
    featuredGameImage = config.featuredGameImage,
    imageOverlay = config.imageOverlay,
    featuredGameImageOverlay = config.featuredGameImageOverlay,
    imageBlurred = config.imageBlurred,
    infoImage = config.infoImage,
    logotype = config.logotype,
    _config$tags = config.tags,
    tags = _config$tags === void 0 ? [] : _config$tags,
    gamePreview = config.gamePreview;
  return _objectSpread(_objectSpread({}, config), {}, {
    gameProvider,
    playUrl: "/spela/".concat(url),
    infoUrl: "/info/".concat(url),
    demoUrl: "/provspela/".concat(url),
    badge: Boolean(badge === null || badge === void 0 ? void 0 : badge.length) && badge,
    trackingName: "lobby-game-".concat(name),
    height: parseInt(height, 10),
    width: parseInt(width, 10),
    margin: parseInt(margin, 10),
    image: images.find(_ref2 => {
      let typeName = _ref2.typeName;
      return typeName === (image === null || image === void 0 ? void 0 : image.name);
    }),
    imageBackground: images.find(_ref3 => {
      let typeName = _ref3.typeName;
      return typeName === (imageBackground === null || imageBackground === void 0 ? void 0 : imageBackground.name);
    }),
    featuredGameImage: images.find(_ref4 => {
      let typeName = _ref4.typeName;
      return typeName === (featuredGameImage === null || featuredGameImage === void 0 ? void 0 : featuredGameImage.name);
    }),
    imageOverlay: images.find(_ref5 => {
      let typeName = _ref5.typeName;
      return typeName === (imageOverlay === null || imageOverlay === void 0 ? void 0 : imageOverlay.name);
    }),
    featuredGameImageOverlay: images.find(_ref6 => {
      let typeName = _ref6.typeName;
      return typeName === (featuredGameImageOverlay === null || featuredGameImageOverlay === void 0 ? void 0 : featuredGameImageOverlay.name);
    }),
    imageBlurred: images.find(_ref7 => {
      let typeName = _ref7.typeName;
      return typeName === (imageBlurred === null || imageBlurred === void 0 ? void 0 : imageBlurred.name);
    }),
    infoImage: images.find(_ref8 => {
      let typeName = _ref8.typeName;
      return typeName === (infoImage === null || infoImage === void 0 ? void 0 : infoImage.name);
    }),
    logotype: images.find(_ref9 => {
      let typeName = _ref9.typeName;
      return typeName === (logotype === null || logotype === void 0 ? void 0 : logotype.name);
    }),
    gamePreview: images.find(_ref0 => {
      let typeName = _ref0.typeName;
      return typeName === (gamePreview === null || gamePreview === void 0 ? void 0 : gamePreview.name);
    }),
    tags
  });
};
const mergeObjects = objList => {
  const mergedObj = {};
  objList.forEach(obj => {
    for (const key in obj) {
      mergedObj[key] = obj[key];
    }
  });
  return mergedObj;
};
const mapGames = function () {
  let result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let leiaGames = arguments.length > 1 ? arguments[1] : undefined;
  let req = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return result.filter(_ref1 => {
    let _ref1$properties$cnt_ = _ref1.properties.cnt_ticketGameCategory,
      category = _ref1$properties$cnt_ === void 0 ? '' : _ref1$properties$cnt_;
    return category === E_INSTANT_CATEGORY;
  }).reduce((ticketList, ticket) => {
    const _ticket$properties = ticket.properties,
      gameProviderId = _ticket$properties.cnt_ticketGameProvider,
      cnt_ticketGameConfig = _ticket$properties.cnt_ticketGameConfig,
      _ticket$properties$cn = _ticket$properties.cnt_ticketGameTags,
      tags = _ticket$properties$cn === void 0 ? [] : _ticket$properties$cn,
      branding = _ticket$properties.cnt_ticketGameCategory,
      _ticket$images = ticket.images,
      images = _ticket$images === void 0 ? [] : _ticket$images;
    const _JSON$parse = JSON.parse(cnt_ticketGameConfig),
      gameProvider = _JSON$parse.gameProvider,
      category = _JSON$parse.category,
      shouldTriggerQualtrics = _JSON$parse.shouldTriggerQualtrics,
      config = _objectWithoutProperties(_JSON$parse, _excluded);
    try {
      const gameProviderConfig = gameProvider.config;
      const eInstantConfig = category.config;
      if (!eInstantConfig) return ticketList;
      const leiaGameConfig = leiaGames.find(game => game.type === gameProviderConfig.leiaType) || {};
      ticketList.push(createGameConfig({
        config: _objectSpread(_objectSpread({}, mergeObjects([gameProviderConfig, eInstantConfig, leiaGameConfig, config], config.name)), {}, {
          publishedDate: ticket.published,
          shouldTriggerQualtrics,
          cntTicketGameId: ticket.id,
          tags,
          branding
        }),
        images,
        gameProvider: gameProviderId
      }));
      return ticketList;
    } catch (e) {
      svs.eInstant.logger.warn("Failed to parse ticket: ".concat(config.name), req);
      return ticketList;
    }
  }, []);
};
if (svs.isServer) {
  const _require = require('@svenskaspelab/trinidad-core'),
    trinidad = _require.core;
  const _trinidad$components$ = trinidad.components.require('ticketgames', 'game-handler'),
    getLeiaGames = _trinidad$components$.getLeiaGames;
  const _require2 = require('./services/ticket-configs.es6'),
    fetchTicketConfigs = _require2.fetchTicketConfigs;
  const fetchAllGames = async req => {
    const _await$Promise$allSet = await Promise.allSettled([getLeiaGames(req), fetchTicketConfigs(req)]),
      _await$Promise$allSet2 = _slicedToArray(_await$Promise$allSet, 2),
      leiaGames = _await$Promise$allSet2[0].value,
      ticketsConfigs = _await$Promise$allSet2[1].value;
    return mapGames(ticketsConfigs, leiaGames);
  };
  module.exports = {
    mapGames,
    fetchAllGames
  };
} else {
  const ALL_GAMES_CACHE_KEY = 'svs.eInstant.shared.util.fetchAllGames';
  const allGamesCache = {};
  const fetchAllGames = async () => {
    if (allGamesCache[ALL_GAMES_CACHE_KEY] && allGamesCache[ALL_GAMES_CACHE_KEY].ttl > Date.now()) {
      return allGamesCache[ALL_GAMES_CACHE_KEY].games;
    }
    const _svs$eInstant$shared$ = svs.eInstant.shared.services,
      fetchLEIAGames = _svs$eInstant$shared$.fetchLEIAGames,
      fetchTicketConfigs = _svs$eInstant$shared$.fetchTicketConfigs;
    const _await$Promise$allSet3 = await Promise.allSettled([fetchLEIAGames(), fetchTicketConfigs()]),
      _await$Promise$allSet4 = _slicedToArray(_await$Promise$allSet3, 2),
      leiaGames = _await$Promise$allSet4[0].value,
      ticketsConfigs = _await$Promise$allSet4[1].value;
    const games = mapGames(ticketsConfigs, leiaGames);
    allGamesCache[ALL_GAMES_CACHE_KEY] = {
      games,
      ttl: Date.now() + 60000
    };
    return games;
  };
  setGlobal('svs.eInstant.shared.util', {
    fetchAllGames
  });
}

 })(window);